/* Ilustre Casa — Avaliações (custom element <ic-reviews>).
   Dados via API pública do Judge.me (reviews_for_widget, plano free); render, filtro,
   paginação e layout são NOSSOS. Markup/CSS seguem a referência do design
   (ui_kits/storefront/shopify/preview-reviews.html).

   O endpoint não filtra/ordena por parâmetro, então buscamos TODAS as avaliações de uma
   vez (per_page alto) e filtramos/ordenamos/paginamos no cliente.

   Uso (em ic-main-product.liquid):
     <ic-reviews data-product-id="{{ p.id }}" data-shop="{{ shop.permanent_domain }}"
                 data-per-page="5"></ic-reviews>
   CSS: assets/ic-reviews.css · Botão "Escrever": aciona o modal do Judge.me ([data-ic-jdgm-write]).
*/
(function () {
  if (customElements.get('ic-reviews')) return;

  var API = 'https://api.judge.me/reviews/reviews_for_widget';
  var STAR = 'M12 2.5l2.9 5.9 6.5.95-4.7 4.58 1.1 6.47L12 17.9l-5.8 3.05 1.1-6.47L2.6 9.9l6.5-.95z';
  var MESES = ['janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho', 'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro'];

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function initials(name) {
    var p = String(name || '').trim().split(/\s+/).filter(Boolean);
    if (!p.length) return '?';
    if (p.length === 1) return p[0].slice(0, 2).toUpperCase();
    return (p[0].charAt(0) + p[p.length - 1].charAt(0)).toUpperCase();
  }
  function fmtDate(iso) {
    try { var d = new Date(iso); return d.getDate() + ' de ' + MESES[d.getMonth()]; } catch (e) { return ''; }
  }
  function hasPics(r) { return (r.pictures_urls || []).length > 0; }

  function stars(n, size) {
    size = size || 16;
    var s = '<span class="ic-stars">';
    for (var i = 1; i <= 5; i++) {
      var on = i <= n;
      s += '<svg width="' + size + '" height="' + size + '" viewBox="0 0 24 24" aria-hidden="true"><path d="' + STAR + '" fill="' + (on ? 'var(--ic-terracota,#BC6C4C)' : 'none') + '" stroke="' + (on ? 'var(--ic-terracota,#BC6C4C)' : 'var(--ic-borda,#C7B79C)') + '" stroke-width="1.5" stroke-linejoin="round"/></svg>';
    }
    return s + '</span>';
  }
  function verifiedBadge() {
    return '<span class="ic-rev__badge ic-rev__badge--verified"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>Compra verificada</span>';
  }
  function importedBadge() {
    return '<span class="ic-rev__badge ic-rev__badge--imported"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><path d="M21 12a9 9 0 1 1-9-9"/><path d="M21 3v6h-6"/></svg>Avaliação importada</span>';
  }

  /* Lightbox singleton — abre a foto da review no próprio site, com carrossel
     (se houver várias) e teclado (←/→/Esc). Anexado ao <body> para ficar acima de tudo. */
  var Lightbox = (function () {
    var el, imgEl, counterEl, prevBtn, nextBtn, urls = [], idx = 0;
    var X = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round"><path d="M18 6 6 18M6 6l12 12"/></svg>';
    var L = '<svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><path d="m15 18-6-6 6-6"/></svg>';
    var R = '<svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><path d="m9 18 6-6-6-6"/></svg>';
    function build() {
      el = document.createElement('div');
      el.className = 'ic-lightbox';
      el.setAttribute('hidden', '');
      el.setAttribute('role', 'dialog');
      el.setAttribute('aria-modal', 'true');
      el.setAttribute('aria-label', 'Foto da avaliação');
      el.innerHTML =
        '<div class="ic-lightbox__backdrop" data-lb-close></div>' +
        '<button class="ic-lightbox__close" type="button" data-lb-close aria-label="Fechar">' + X + '</button>' +
        '<button class="ic-lightbox__nav ic-lightbox__prev" type="button" data-lb-prev aria-label="Foto anterior">' + L + '</button>' +
        '<figure class="ic-lightbox__stage"><img class="ic-lightbox__img" alt=""></figure>' +
        '<button class="ic-lightbox__nav ic-lightbox__next" type="button" data-lb-next aria-label="Próxima foto">' + R + '</button>' +
        '<div class="ic-lightbox__counter" aria-live="polite"></div>';
      document.body.appendChild(el);
      imgEl = el.querySelector('.ic-lightbox__img');
      counterEl = el.querySelector('.ic-lightbox__counter');
      prevBtn = el.querySelector('[data-lb-prev]');
      nextBtn = el.querySelector('[data-lb-next]');
      el.addEventListener('click', function (e) {
        if (e.target.closest('[data-lb-close]')) close();
        else if (e.target.closest('[data-lb-prev]')) go(-1);
        else if (e.target.closest('[data-lb-next]')) go(1);
      });
    }
    function show() {
      imgEl.style.opacity = '0';
      var im = new Image();
      im.onload = function () { imgEl.src = urls[idx]; imgEl.style.opacity = '1'; };
      im.src = urls[idx];
      var multi = urls.length > 1;
      prevBtn.hidden = nextBtn.hidden = !multi;
      counterEl.hidden = !multi;
      counterEl.textContent = (idx + 1) + ' / ' + urls.length;
    }
    function go(d) { idx = (idx + d + urls.length) % urls.length; show(); }
    function onKey(e) {
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowLeft') go(-1);
      else if (e.key === 'ArrowRight') go(1);
    }
    function open(list, start) {
      if (!el) build();
      urls = list; idx = start || 0;
      show();
      el.removeAttribute('hidden');
      requestAnimationFrame(function () { el.classList.add('is-open'); });
      document.addEventListener('keydown', onKey);
      document.documentElement.style.overflow = 'hidden';
    }
    function close() {
      el.classList.remove('is-open');
      document.removeEventListener('keydown', onKey);
      document.documentElement.style.overflow = '';
      setTimeout(function () { el.setAttribute('hidden', ''); imgEl.src = ''; }, 240);
    }
    return { open: open };
  })();

  class ICReviewsEl extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;
      this.productId = this.dataset.productId;
      this.shop = this.dataset.shop;
      this.perPage = parseInt(this.dataset.perPage || '5', 10) || 5;
      this.state = { all: [], hist: [], avg: '0', count: 0, chip: 'all', page: 1, status: 'loading' };
      this.render();
      this.load();
      this.addEventListener('click', this.onClick.bind(this));
    }

    async load() {
      try {
        var url = API + '?url=' + encodeURIComponent(this.shop) +
          '&shop_domain=' + encodeURIComponent(this.shop) +
          '&platform=shopify&product_id=' + encodeURIComponent(this.productId) +
          '&per_page=100&page=1';
        var res = await fetch(url, { credentials: 'omit' });
        if (!res.ok) throw new Error('status ' + res.status);
        var data = await res.json();
        this.state.all = data.reviews || [];
        this.state.hist = data.histogram || [];
        this.state.avg = data.average_rating || '0';
        this.state.count = data.number_of_reviews || this.state.all.length;
        this.state.status = this.state.count ? 'ready' : 'empty';
        this.render();
      } catch (e) {
        this.state.status = 'error';
        this.render();
      }
    }

    view() {
      var list = this.state.all.slice();
      var c = this.state.chip;
      if (c === 'photo') list = list.filter(hasPics);
      else if (c === '5') list = list.filter(function (r) { return r.rating === 5; });
      if (c === 'recent') list.sort(function (a, b) { return new Date(b.created_at) - new Date(a.created_at); });
      return list;
    }

    onClick(e) {
      var pic = e.target.closest('.ic-rev__pic');
      if (pic) {
        e.preventDefault();
        var box = pic.closest('.ic-rev__pics');
        var links = box ? [].slice.call(box.querySelectorAll('.ic-rev__pic')) : [pic];
        Lightbox.open(links.map(function (a) { return a.getAttribute('href'); }), links.indexOf(pic));
        return;
      }
      var write = e.target.closest('.ic-rev-write');
      if (write) { var trigger = document.querySelector('.jdgm-write-rev-link'); if (trigger) trigger.click(); return; }
      var chip = e.target.closest('[data-chip]');
      if (chip) { this.state.chip = chip.getAttribute('data-chip'); this.state.page = 1; this.render(); return; }
      var pg = e.target.closest('[data-page]');
      if (pg) { this.state.page = parseInt(pg.getAttribute('data-page'), 10); this.render(); this.scrollIntoView({ behavior: 'smooth', block: 'start' }); return; }
    }

    reviewHTML(r) {
      var badge = r.verified_buyer ? verifiedBadge()
        : ((r.transparency_badges || []).indexOf('review_collected_from_another_provider') > -1 ? importedBadge() : '');
      var av = r.avatar_image_url
        ? '<div class="ic-rev__avatar" style="background:url(' + esc(r.avatar_image_url) + ') center/cover"></div>'
        : '<div class="ic-rev__avatar">' + esc(initials(r.reviewer_name)) + '</div>';
      var pics = hasPics(r)
        ? '<div class="ic-rev__pics">' + r.pictures_urls.map(function (u) {
            // pictures_urls são objetos {original, small, compact, huge} — não strings.
            var thumb = (u && (u.small || u.compact || u.original)) || u;
            var full = (u && (u.original || u.huge)) || thumb;
            return '<a class="ic-rev__pic" href="' + esc(full) + '" target="_blank" rel="noopener"><img src="' + esc(thumb) + '" loading="lazy" alt=""></a>';
          }).join('') + '</div>'
        : '';
      var reply = r.reply_content
        ? '<div class="ic-rev__reply"><span class="ic-rev__reply-name">' + esc(r.shop_reply_name || 'Ilustre Casa') + '</span>' + r.reply_content + '</div>'
        : '';
      return '<div class="ic-rev">' + av + '<div>' +
        '<div class="ic-rev__head"><span class="ic-rev__author">' + esc(r.reviewer_name || 'Anônimo') + '</span>' + badge +
          '<span class="ic-rev__date">' + fmtDate(r.created_at) + '</span></div>' +
        '<div class="ic-rev__stars">' + stars(r.rating, 15) + '</div>' +
        (r.title ? '<div class="ic-rev__title">' + esc(r.title) + '</div>' : '') +
        '<p class="ic-rev__body">' + (r.body_html || '') + '</p>' +
        pics + reply +
      '</div></div>';
    }

    render() {
      var s = this.state;
      if (s.status === 'loading') { this.innerHTML = '<div class="ic-rev-msg">Carregando avaliações…</div>'; return; }
      if (s.status === 'error') { this.innerHTML = '<div class="ic-rev-msg">Não foi possível carregar as avaliações agora.</div>'; return; }
      if (s.status === 'empty') {
        this.innerHTML = '<div class="ic-rev-empty"><div class="ic-rev-empty__stars">' + stars(0, 22) + '</div>' +
          '<h3>Ainda sem avaliações</h3><p>Seja a primeira pessoa a avaliar esta peça e ajude quem vem depois.</p>' +
          '<button class="ic-rev-write" type="button">Escrever a primeira avaliação</button></div>';
        return;
      }

      // Histograma 5→1
      var self = this;
      var hist = [5, 4, 3, 2, 1].map(function (n) {
        var row = (s.hist || []).filter(function (h) { return h.rating === n; })[0] || { frequency: 0, percentage: 0 };
        return '<div class="ic-histo__row"><span>' + n + '</span>' +
          '<svg width="13" height="13" viewBox="0 0 24 24" aria-hidden="true"><path d="' + STAR + '" fill="var(--ic-terracota,#BC6C4C)"/></svg>' +
          '<span class="ic-histo__bar"><span class="ic-histo__fill" style="width:' + row.percentage + '%"></span></span>' +
          '<span class="ic-histo__n">' + row.frequency + '</span></div>';
      }).join('');

      // Chips com contagem
      var withPhoto = s.all.filter(hasPics).length;
      var five = s.all.filter(function (r) { return r.rating === 5; }).length;
      var chipDefs = [
        { key: 'all', label: 'Todas', n: s.count },
        { key: 'photo', label: 'Com foto', n: withPhoto },
        { key: '5', label: '5 estrelas', n: five },
        { key: 'recent', label: 'Mais recentes', n: null }
      ];
      var chips = chipDefs.map(function (c) {
        return '<button class="ic-chip' + (s.chip === c.key ? ' is-on' : '') + '" type="button" data-chip="' + c.key + '">' +
          c.label + (c.n != null ? ' <span class="ic-chip__n">' + c.n + '</span>' : '') + '</button>';
      }).join('');

      // Lista paginada
      var list = this.view();
      var totalPages = Math.max(1, Math.ceil(list.length / this.perPage));
      if (s.page > totalPages) s.page = totalPages;
      var start = (s.page - 1) * this.perPage;
      var pageItems = list.slice(start, start + this.perPage);
      var items = pageItems.length
        ? pageItems.map(function (r) { return self.reviewHTML(r); }).join('')
        : '<div class="ic-rev-msg">Nenhuma avaliação com esse filtro.</div>';

      // Paginação
      var pag = '';
      if (totalPages > 1) {
        var btns = '';
        if (s.page > 1) btns += '<button class="ic-page" type="button" data-page="' + (s.page - 1) + '" aria-label="Anterior">‹</button>';
        for (var i = 1; i <= totalPages; i++) {
          btns += '<button class="ic-page' + (i === s.page ? ' is-on' : '') + '" type="button" data-page="' + i + '">' + i + '</button>';
        }
        if (s.page < totalPages) btns += '<button class="ic-page" type="button" data-page="' + (s.page + 1) + '" aria-label="Próxima">›</button>';
        pag = '<div class="ic-paginate">' + btns + '</div>';
      }

      var avgBr = (Math.round(Number(s.avg) * 10) / 10).toFixed(1).replace('.', ',');

      this.innerHTML =
        '<div class="ic-rev-summary">' +
          '<div class="ic-rev-summary__avg">' +
            '<div class="ic-rev-summary__num">' + avgBr + '</div>' +
            '<div>' + stars(Math.round(Number(s.avg)), 15) + '</div>' +
            '<div class="ic-rev-summary__count">' + s.count + ' avaliações</div>' +
          '</div>' +
          '<div class="ic-histo">' + hist + '</div>' +
          '<button class="ic-rev-write" type="button">Escrever avaliação</button>' +
        '</div>' +
        '<div class="ic-rev-filters">' + chips + '</div>' +
        '<div class="ic-rev-list">' + items + '</div>' +
        '<div class="ic-rev-foot"><span class="ic-rev-brand">Avaliações por Judge.me</span>' + pag + '</div>';
    }
  }

  customElements.define('ic-reviews', ICReviewsEl);
})();
